export const hobbiesInfo = {
  padel: {
    image: {
      src: "padel.jpg",
      alt: "Photo of a padel court.",
    },
  },
  basketball: {
    image: {
      src: "basketball.jpg",
      alt: "Photo of a basketball court.",
    },
  },
  photography: {
    image: {
      src: "camera.jpg",
      alt: "Photo of a photographer taking a photo.",
    },
  },
};
